import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Level, Clipped, Disclosure, List, Price, Image, IconManager, Link, bookshelfLogoPack, coreIconPack, Media, Text, Divider, DescriptionList } from '@deseretbook/react-ui'
import DeliveryMethod from './DeliveryMethod'

IconManager.register(coreIconPack, bookshelfLogoPack)

/**
 * Shipment information including delivery method and contents
 *
 * @returns {function} Component
 */
const ShipmentContent = ({ shipAddress, shipments }) => {
  const personalizationDisplayTypes = { 'Spree::Personalization::Imprint': 'Imprint Personalization', 'Spree::Personalization::Art': 'Art Personalization' }

  return(
    <React.Fragment>
      {shipments.map(shipment => (
        <Box key={shipment.id} paddingBottom={3} >
          <DeliveryMethod
            shipment={shipment}
            shipAddress={shipAddress}
            shipmentIndex={shipments.length > 1
              ? shipments.indexOf(shipment)
              : undefined}
          />
          <Divider />
          {/* Line item information */}
          {shipment.lineItems.map(lineItem => (
            <Media key={lineItem.id}>
              {lineItem.variant.images.length > 0 && (
                <Media.Figure size="small" isShrinkable className="hidden-print">
                  <Link href={`/p/${lineItem.variant.slug}`} style={{ display: 'block', width: '100%' }}>
                    <Image
                      src={lineItem.variant.images[0].smallUrl}
                      alt={lineItem.variant.images[0].alt || lineItem.variant.name}
                      imageWidth={lineItem.variant.images[0].attachmentWidth}
                      imageHeight={lineItem.variant.images[0].attachmentHeight}
                    />
                  </Link>
                </Media.Figure>
              )}
              <Media.Content>
                <Level>
                  <Level.Left isShrinkable>
                    <Level.Item>
                      <Clipped>
                        <Link href={`/p/${lineItem.variant.slug}`}><Text hasEllipsis>{lineItem.variant.name}</Text></Link>
                        <Text size="tiny" color="muted" hasEllipsis>
                          {lineItem.variant.optionValues.map(({ presentation }) => presentation).join(' ')}
                        </Text>
                        <List type="horizontal">
                          <List.Item>
                            <Price value={lineItem.price} />
                          </List.Item>
                          <List.Item>
                            <Text><Text color="muted">Qty</Text> {lineItem.quantity}</Text>
                          </List.Item>
                        </List>
                        {/* Personalizations */}
                        {lineItem.personalization && (
                          <Disclosure>
                            <Disclosure.Header>
                              {personalizationDisplayTypes[lineItem.personalization.personalization.type] || 'Personalization'}
                            </Disclosure.Header>
                            <Disclosure.Content>
                              <DescriptionList>
                                {lineItem.personalization.data.lines.map(line => (
                                  <React.Fragment>
                                    <DescriptionList.Term>
                                      {line.title}
                                    </DescriptionList.Term>
                                    <DescriptionList.Description>
                                      {line.value}
                                    </DescriptionList.Description>
                                  </React.Fragment>
                                ))}
                                {!!lineItem.personalization.data.style && (
                                  <React.Fragment>
                                    <DescriptionList.Term>
                                      Style
                                    </DescriptionList.Term>
                                    <DescriptionList.Description>
                                      {lineItem.personalization.data.style}
                                    </DescriptionList.Description>
                                  </React.Fragment>
                                )}
                              </DescriptionList>
                            </Disclosure.Content>
                          </Disclosure>
                        )}
                        {/* Buttons for digital items */}
                        {(lineItem.variant['ebook?'] || lineItem.variant['audiobook?'] || lineItem.variant['download?']) && (
                          <Box paddingTop={0.5}>
                            <Level>
                              {/* Bookshelf button to go to read.deseretbook.com */}
                              {(lineItem.variant['ebook?'] || lineItem.variant['audiobook?']) && (
                                <Level.Item>
                                  <Button className="hidden-print" asComponent="a" color="bookshelf" href="https://read.deseretbook.com">Open in Bookshelf</Button>
                                </Level.Item>
                              )}
                              {/* Download button for downloadable items */}
                              {lineItem.variant['download?'] && (
                                <Level.Item>
                                  <Button className="hidden-print" asComponent="a" color="primary" icon="download" href={`/digital/${lineItem.digitalLinks[0].secret}`}>Download</Button>
                                </Level.Item>
                              )}
                            </Level>
                          </Box>
                        )}
                      </Clipped>
                    </Level.Item>
                  </Level.Left>
                </Level>
              </Media.Content>
            </Media>
          ))}
        </Box>
      ))}
    </React.Fragment>
  )
}

ShipmentContent.propTypes = {
  shipAddress: PropTypes.shape({}),
  shipments: PropTypes.arrayOf(PropTypes.shape({})),
}

ShipmentContent.defaultProps = {
  shipAddress: {},
  shipments: [],
}

export default ShipmentContent

